<template>
  <div class="page">
    <van-nav-bar title="品牌工作台" left-arrow @click-left="$router.back()"/>
    <section class="summary"><strong>{{ brandPost }}</strong><span>岗位工作流已启用</span></section>
    <van-cell-group>
      <van-cell title="内容创作台" label="素材、AI生成、评测与发布" icon="edit" is-link to="/brand/create"/>
      <van-cell title="品牌战略方向" label="查看或制定品牌要求" icon="flag-o" is-link to="/brand/direction"/>
      <van-cell title="品牌效果" label="产出、互动与转化" icon="bar-chart-o" is-link to="/brand/report"/>
      <van-cell title="我的价值榜" label="最终复核分与公司排名" icon="medal-o" is-link to="/brand/rank/me"/>
      <van-cell title="项目价值榜" label="项目交付、价值分与健康度" icon="chart-trending-o" is-link to="/brand/rank/projects"/>
      <van-cell v-if="boss" title="公司价值榜驾驶舱" label="员工与项目双榜单" icon="manager-o" is-link to="/brand/rank/company"/>
      <van-cell title="我的方向与今日策略" label="低分表现结合外部情报生成建议" icon="bulb-o" is-link to="/brand/direction/me"/>
      <van-cell v-if="boss" title="AI 公司策略建议" label="策略下发与 brand.* skill 修订" icon="cluster-o" is-link to="/brand/strategy"/>
      <van-cell v-if="boss" title="内容样本审核" label="审核优秀与失败内容，沉淀可复用样本" icon="passed" is-link to="/brand/samples"/>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  computed: {
    brandPost() {
      return localStorage.getItem("CoreBrandPost") || "品牌岗位";
    }, boss() {
      return localStorage.getItem("CoreIsBoss") === "true"
    }
  }
};
</script>
<style scoped>
.page {
  min-height: 100vh;
  background: #f5f6f8
}

.summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .34rem;
  background: #fff;
  border-bottom: 1px solid #eee
}

.summary strong {
  font-size: .34rem
}

.summary span {
  font-size: .24rem;
  color: #777
}
</style>



// WEBPACK FOOTER //
// src/views/brand/BrandHome.vue